import { render, staticRenderFns } from "./VotingContest.vue?vue&type=template&id=4f9c3a14&scoped=true"
import script from "./VotingContest.vue?vue&type=script&lang=js"
export * from "./VotingContest.vue?vue&type=script&lang=js"
import style0 from "./VotingContest.vue?vue&type=style&index=0&id=4f9c3a14&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f9c3a14",
  null
  
)

export default component.exports